module.exports = __webpack_public_path__ + "static/media/Telephone.5d78904d.svg";